export default __webpack_public_path__ + "static/media/1266.77cab23b.png";